/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_H1Inputs */

const en_viewer_h1 = /** @type {(inputs: Viewer_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online JSON Viewer & Explorer`)
};

const ko_viewer_h1 = /** @type {(inputs: Viewer_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인 JSON 뷰어 & 탐색기`)
};

const ja_viewer_h1 = /** @type {(inputs: Viewer_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインJSONビューアー＆エクスプローラー`)
};

/**
* | output |
* | --- |
* | "Online JSON Viewer & Explorer" |
*
* @param {Viewer_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_h1 = /** @type {((inputs?: Viewer_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_h1(inputs)
	if (locale === "ko") return ko_viewer_h1(inputs)
	return ja_viewer_h1(inputs)
});